import React from "react";
import { Link } from "react-router-dom";

export const ProductLinkRenderer = ({ value, data }) => {
    if (!data) return null;
    // This component is used in both inventory and inventory history grid
    // In history grid, the product info is found under `inventory` property
    return <Link to={`/product/${data.product_id || data.inventory.product_id}`}>{value}</Link>;
};
